module.exports = "/_next/static/images/ico_spr.549llFAr.png";